function FolderFile(props) {
  return (
    <div className={"folderFile"+(props.selected ? " folderFileSelect" : "")} onClick={()=>{props.openPage(props.id)}}>
      <img src={`images/portfolio/${props.id}_icon.png`} className="folderFileIcon" draggable={false} alt=""></img>
      <span className="folderFileName">{props.title}</span>
    </div>
  );
}

export default FolderFile;